const PositionBannerVerticalType = {
  LEFT: 1,
  RIGHT: 2
}
export default PositionBannerVerticalType
